import { render, staticRenderFns } from "./MessageCreateAccordionButton.vue?vue&type=template&id=7e4206c6"
import script from "./MessageCreateAccordionButton.vue?vue&type=script&lang=js"
export * from "./MessageCreateAccordionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports